import { desktopCard } from "@ui/components/SheetSurface";
import { tv } from "@ui/lib/tv";

export const pageBackdrop = tv({
  base: "bg-black/40",
  variants: {
    // The fullscreen mobile page covers the viewport — no scrim needed there;
    // desktop shows the detached card over a scrim, and push navigation dims
    // the parallaxing page behind.
    platform: {
      ios: "bg-black/20",
      android: "bg-black/20",
      desktop: "",
    },
  },
});

/**
 * The Page skin. Mobile: a fullscreen page, edge to edge (the iOS
 * cover-vertical / push idiom). Desktop: the shared detached card, xl by
 * default — so a routed flow keeps its desktop appearance whichever mobile
 * presentation it opts into.
 */
export const pagePanel = tv({
  extend: desktopCard,
  variants: {
    platform: {
      ios: "bg-white",
      android: "bg-white",
      desktop: "",
    },
  },
  compoundVariants: [{ chrome: "bare", class: "bg-transparent", platform: ["ios", "android"] }],
});
